/**
 * Simple video component.
 */
define([
    'jQuery',
    'library/fcse-compatibility/object',
    'library/fcse-component/optionsMixin'
    ],
    function($, Object, OptionsMixin) {
        var SimpleVideo = function(element, options) {
            // Set default options
            var defaultOptions = {
                videoTriggerSelector: '[data-fcse-role="video-trigger"]',
                videoHrefAttribute: 'video-href',
                imageHrefAttribute: 'src',
                targetSelector: '[data-fcse-role="reviews-video"]',
                headerSelector: '[data-fcse-role="video-header"]',
                authorSelector: '[data-fcse-role="video-author"]',
                videoTemplateSelector: '#video-template'
            };
            this.addOptions(defaultOptions, options);

            // Store element
            this.element = $(element);
            this._init();
        };
        SimpleVideo.prototype = $.extend(Object.create(OptionsMixin), {
            _init: function() {
                var videoTriggerSelector = this.option('videoTriggerSelector'),
                    videoHrefAttribute = this.option('videoHrefAttribute'),
                    imageHrefAttribute = this.option('imageHrefAttribute'),
                    targetSelector = this.option('targetSelector'),
                    headerSelector = this.option('headerSelector'),
                    authorSelector = this.option('authorSelector'),
                    videoTemplateSelector = this.option('videoTemplateSelector');
                this.element.each(function() {
                    $(this).on('click', videoTriggerSelector, function (e) {
                        var parent = $(this).closest(targetSelector),
                            href = $('['+videoHrefAttribute+']', parent).attr(videoHrefAttribute),
                            imghref = $('['+imageHrefAttribute+']', parent).attr(imageHrefAttribute),
                            header = $(headerSelector, parent).text(),
                            author = $(authorSelector, parent).text(),
                            template = $(videoTemplateSelector).html(),
                            html = $(template
                                    .replace(/\$href/g, href)
                                    .replace(/\$header/g, header)
                                    .replace(/\$author/g, author)
                                    .replace(/\$img/g, imghref)
                                    );
                        html.modal();
                        return false;
                    });
                });
            }
        });
        
        return SimpleVideo;
    });


// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/components/simplevideo/simplevideo.js